import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class LoginLimitConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getLoginLimitEndpoint(): string {
		return this.configService.get(
			(x) => x.common.responsibleGaming.endpoints!.loginLimit,
			"v1/currentcustomerlimits/logincountlimit"
		);
	}

	getLoginLimitProgressEndpoint(): string {
		return this.configService.get(
			(x) => x.common.responsibleGaming.endpoints?.loginLimitProgress,
			"v1/currentcustomerlimits/logincountlimit/status"
		);
	}
}
